export default function Genre(props){
    return (
        <div className="genre-name"><strong>{props.value}</strong></div>
    )
}